import Jobs from "../Jobs/Jobs";

export default function HeatManagementLanding() {
  return (
    <Jobs
      detailBasePath="/heat-management"
      moduleTitle="Heat Management"
      showJobActions={false}
    />
  );
}
